import * as React from 'react';

import cx from 'classnames';

import s from './InfoBlock.module.css';

type TProps = {
  name?: string;
  as?: React.ElementType;
  children: React.ReactNode;
  className?: string;
};

export const InfoBlock = ({
  children,
  className,
  as = 'section',
  name,
}: TProps) => {
  const Component = as;

  return (
    <Component className={cx(s.infoBlock, className)} name={name}>
      {children}
    </Component>
  );
};
